<template>
  <div class="common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">渠道账号：</div>
          <div class="content">
            <el-input v-model="form.groupId" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">渠道名称：</div>
          <div class="content">
            <el-input v-model="form.groupName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">渠道对应销售：</div>
          <div class="content">
            <el-input v-model="form.saleIdOrName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="addBtn">添加</el-button>
      <el-button plain @click="refreshBtn">刷新销售</el-button>
    </div>
    <commonTable ref="channelAccountTable" />
    <addChannelAccountDialog
      @addAccountSubHandle="addAccountSubHandle"
      @editAccountSubHandle="editAccountSubHandle"
      @dialogCloseHandle="dialogCloseHandle"
      :channel-account-dialog-visible="channelAccountDialogVisible"
      :row-data="rowData"
    />
    <rejectDialog
      :reject-dialog-show="rejectDialogShow"
      @dialogCloseHandle="rejectDialogClose"
      @submitHandler="rejectSubmitHandler"
    />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import addChannelAccountDialog from './component/channelAccountManagement/addChannelAccountDialog';
import rejectDialog from './component/channelAccountManagement/rejectDialog';
import { channelAccountManagementApi } from './service';
import { qdSignContractApi } from '@/API/home';

export default {
  data () {
    return {
      tableData: [],
      form: {},
      rowData: {},
      channelAccountDialogVisible: false,
      rejectDialogShow: false
    };
  },
  components: {
    commonTable,
    addChannelAccountDialog,
    rejectDialog
  },
  methods: {
    rejectHandler (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.rejectDialogShow = true;
    },
    rejectSubmitHandler (data) {
      let params = {
        ...data,
        ...this.rowData
      };
      this.rejectApproved(params, 4);
    },
    rejectDialogClose () {
      this.rejectDialogShow = false;
      this.rowData = {};
    },
    rejectApproved (item, state) {
      let params = {
        groupId: item.sysGroupPermisson.groupId,
        groupPermissonId: item.sysGroupPermisson.id,
        stat: state,
        fileId: item.attachFile ? item.attachFile.fileId : ''
      };

      if (state === 4) {
        params.rejectReason = item.rejectReason;
        this.updateStateRequest(params);
      }
      if (state === 1) {
        this.$confirm('是否确定审批通过?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.updateStateRequest(params);
        }).catch(() => {

        });
      }
    },
    updateStateRequest (params) {
      this.$store.commit('setSubPageLoading', true);
      channelAccountManagementApi.channelAccountUpdateStat(params).then(res => {
        this.$store.commit('setSubPageLoading', false);
        if (res.status === '200') {
          this.searchBtn();
          if (params.stat === 4) this.rejectDialogShow = false;
          this.$message.success('操作成功');
        }
      });
    },
    editAccountSubHandle (data) {
      let params = {
        groupPermissonId: data.groupPermissonId,
        qdBillingId: data.qdBillingId,
        groupId: data.groupId,
        groupName: data.groupName,
        partnerName: data.partnerName,
        bankAcount: data.bankAcount,
        taxPayerCode: data.taxPayerCode,
        stat: data.stat
      };
      this.$store.commit('setSubPageLoading', true);
      channelAccountManagementApi.channelAccountUpdate(params).then(res => {
        if (res.status === '200') {
          this.$message.success('編輯成功');
          this.channelAccountDialogVisible = false;
          this.loadTable();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    editHandlen (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.channelAccountDialogVisible = true;
    },
    enableDisableHandle (row) {
      let params = {
        groupPermissonId: row.sysGroupPermisson.id,
        stat: row.sysGroupPermisson.stat === 1 ? 0 : 1
      };
      channelAccountManagementApi.channelAccountUpdateStat(params).then(res => {
        if (res.status === '200') {
          this.loadTable();
          this.$message.success('操作成功');
        }
      });
    },
    addBtn () {
      this.channelAccountDialogVisible = true;
    },
    refreshBtn () {
      this.$confirm('确定执行刷新操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('setSubPageLoading', true);
        channelAccountManagementApi.refreshAccount().then(res => {
          if (res.status === '200') {
            this.$message.success('刷新成功');
            this.loadTable();
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }).catch(() => {

      });
    },
    addAccountSubHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      channelAccountManagementApi.addChannelAccount(data).then(res => {
        if (res.status === '200') {
          this.$message.success('添加成功');
          this.channelAccountDialogVisible = false;
          this.loadTable();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    dialogCloseHandle () {
      this.rowData = {};
      this.channelAccountDialogVisible = false;
    },
    reset () {
      this.form = {};
      this.tableData = [];
    },
    arrayQuery (val, list, findKey) {
      return list.find(item => {
        return item[findKey] === val;
      });
    },
    searchBtn () {
      this.$refs.channelAccountTable.getTableData({ url: '/sys_group_permisson/list', params: this.form });
    },
    fileDownload (row) {
      if (row.sysGroupPermisson) {
        qdSignContractApi.getSigningAfterFile(row.sysGroupPermisson.groupId).then(res => {
          if (res.status === '200') {
            let xhr = new XMLHttpRequest();
            xhr.open('GET', res.data, true);
            xhr.responseType = 'blob';
            xhr.onload = () => {
              if (xhr.status === 200) {
                let link = document.createElement('a');
                let body = document.querySelector('body');
                link.href = window.URL.createObjectURL(xhr.response);
                link.download = `活动筹办合作框架协议-${ row.sysGroupPermisson.groupName }-${row.sysGroupPermisson.contractDateTwo}.pdf`;
                link.style.display = 'none';
                body.appendChild(link);
                link.click();
                body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
              }
            };
            xhr.send();
          }
        });
      }
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('渠道账号')
          ._width('120')
          ._data('sysGroupPermisson.groupId')
      );
      tableRow.push(
        new TableColumns()
          ._title('渠道名称')
          ._width('120')
          ._data('sysGroupPermisson.groupName')
      );
      tableRow.push(
        new TableColumns()
          ._title('银行账户名')
          ._width('120')
          ._data('qdBilling.partnerName')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <span>{ row.sysGroupPermisson.bankAcountName ? row.sysGroupPermisson.bankAcountName : row.qdBilling.partnerName }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('银行账号')
          ._width('120')
          ._data('qdBilling.bankAcount')
      );
      tableRow.push(
        new TableColumns()
          ._title('税号')
          ._width('120')
          ._data('qdBilling.taxPayerCode')
      );
      tableRow.push(
        new TableColumns()
          ._title('销售邮箱')
          ._width('120')
          ._data('sysGroupPermisson.saleId')
      );
      tableRow.push(
        new TableColumns()
          ._title('框架协议')
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span class="btnText" onClick={() => { this.fileDownload(row); }}>
                    {
                      row.attachFile && row.attachFile.fileId
                        ? `活动筹办合作框架协议-${ row.sysGroupPermisson.groupName }-${ row.sysGroupPermisson.contractDateTwo }`
                        : ''
                    }
                  </span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('销售名称')
          ._width('100')
          ._data('sysGroupPermisson.saleName')
      );
      tableRow.push(
        new TableColumns()
          ._title('创建人')
          ._width('80')
          ._data('sysGroupPermisson.createUser')
      );
      tableRow.push(
        new TableColumns()
          ._title('创建时间')
          ._width('100')
          ._data('sysGroupPermisson.createTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = row.sysGroupPermisson.createTime ? new Date(row.sysGroupPermisson.createTime.replace(/-/g, '/')).format('yyyy-MM-dd') : '';
              return (
                <span>{date}</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('更新人')
          ._width('80')
          ._data('sysGroupPermisson.updateUserName')
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('120')
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  {
                    row.sysGroupPermisson.stat !== 1 && row.sysGroupPermisson.stat !== 4
                      ? (
                        <el-button type="text" onClick={() => {
                            this.rejectApproved(row, 1);
                          }}>通过</el-button>
                      ) : null
                  }
                  {
                    row.sysGroupPermisson.stat !== 4 ? (
                      <el-button type="text" onClick={() => {
                        this.rejectHandler(row);
                      }}>驳回</el-button>
                    ) : null
                  }
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('状态')
          ._width('100')
          ._data('sysGroupPermisson.stat')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let statusText = '';
              switch (row.sysGroupPermisson.stat) {
                case 0:
                  statusText = '无权限';
                  break;
                case 1:
                    statusText = '生效中';
                    break;
                case 2:
                  statusText = '签约未完成';
                  break;
                case 3:
                  statusText = '待审批';
                  break;
                case 4:
                  statusText = '被驳回';
                  break;
              }
              return (
                <div>
                  <span>{ statusText }</span>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.channelAccountTable.setColumn(column);
      this.$refs.channelAccountTable.loadTable({ url: '/sys_group_permisson/list', listKey: 'list' });
    }
  },
  mounted () {
    this.loadTable();
  }
};
</script>

<style scoped>

</style>
